import { FormHelperText } from '@mui/material';
import CustomFileUpload from 'app/components/CustomFileUpload';
import { useAniPayFileUpload } from 'app/pages/anipay/api/usePaymentFlow';
import { FileObject, FormFieldValues } from 'app/pages/anipay/model/types';
import { sanitizeFileName } from 'app/utils/file/sanitizeFileName';
import { enqueueSnackbar } from 'notistack';
import { FileRejection } from 'react-dropzone/.';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const NewPaymentFileUpload = () => {
  const { t } = useTranslation();
  const {
    getValues,
    setValue,
    formState: { errors },
    setError,
  } = useFormContext<FormFieldValues>();
  const { isLoading, mutate } = useAniPayFileUpload();
  const downloadedFiles = getValues('files') as FileObject[];

  const setFilesToForm = (fileName: FileObject) => {
    setValue('files', [...(downloadedFiles ?? []), fileName], { shouldValidate: true });
  };

  const handleDeleteFile = (item: FileObject) => {
    const newFiles = downloadedFiles.filter(file => file.file_id !== item.file_id);
    setValue('files', newFiles.length === 0 ? null : newFiles, { shouldValidate: true });
  };

  const onDrop = (acceptedFiles: File[], fileRejection: FileRejection[]) => {
    if (downloadedFiles && downloadedFiles.length === 10) {
      setError('files', { type: 'error', message: t('guarantee.uploadedMaxFileCount') });

      return;
    }
    try {
      const file = acceptedFiles[0];
      const sanitizedFileName = sanitizeFileName(file.name);
      const overratedFile: any = new File([file], sanitizedFileName, { type: file.type });

      if (fileRejection[0]?.errors[0].code === 'file-too-large') {
        setError('files', { type: 'error', message: t('guarantee.file_too_large') });
      } else {
        /* This log debugger ensures that for production env.*/
        const formData = new FormData();
        formData.append('file', overratedFile);
        formData.append('file_name', overratedFile.name);

        mutate(formData, {
          onSuccess: ({ data }: any) => {
            const { file_name } = data;

            if (file_name) {
              const fileObject = {
                name: overratedFile.name,
                size: overratedFile.size,
                file_id: file_name,
              };
              setFilesToForm(fileObject);
            }
          },
          onError: () => {
            setError('files', { type: 'error', message: t('guarantee.file_upload_error') });
          },
        });
      }
    } catch (err) {
      console.log('err : ', err);
      enqueueSnackbar('Something went wrong when uploading file', {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        variant: 'error',
      });
    }
  };

  return (
    <>
      <CustomFileUpload
        onDrop={onDrop}
        withOutDetails={false}
        file={downloadedFiles}
        deleteFile={handleDeleteFile}
        fileSize={'30 Mb'}
        isLoading={isLoading}
      />
      {errors.files && (
        <FormHelperText sx={{ color: 'red' }}>{errors.files.message}</FormHelperText>
      )}
    </>
  );
};

export default NewPaymentFileUpload;
